module.exports = __webpack_public_path__ + "static/media/circle.179f76d1.gif";